import { createAsyncThunk } from '@reduxjs/toolkit';
import { SalesTextApi } from '../../api/SalesTextApi';

//Gets paginated salestext data
export const getSalesText = createAsyncThunk(
  'salesText/getSalesText',
  async (
    action: { page: number; limit: number; searchCode?: string; materialCode?: string },
    thunkAPI
  ) => {
    action.materialCode = action.searchCode;
    return SalesTextApi.getSalesText(action, thunkAPI.dispatch);
  }
);
